import { render, staticRenderFns } from "./PlantRegisterNew.vue?vue&type=template&id=84f6ffbe&scoped=true&"
import script from "./PlantRegisterNew.vue?vue&type=script&lang=js&"
export * from "./PlantRegisterNew.vue?vue&type=script&lang=js&"
import style0 from "./PlantRegisterNew.vue?vue&type=style&index=0&id=84f6ffbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f6ffbe",
  null
  
)

export default component.exports